import './styles.scss'
import * as React from 'react'
import { Collapse } from 'reactstrap'

import { Button } from 'components/Form'
import DaysRange from '../DaysRange'
import { lang } from 'utils/helpers'

const Index = (props) => {
  const options = [
    lang('dashboard_every-day'),
    lang('dashboard_weekday'),
    lang('dashboard_personalized')
  ]
  const [isOpenSchedules, setIsOpenSchedules] = React.useState({
    faqConsoleSchedule: true,
    aiBotSchedule: false,
    smartChatSchedule : false
  })
  const [selectedOptionFaq, setSelectedOptionFaq] = React.useState({ value: '', label: lang('dashboard_every-day') })
  const [selectedOptionAi, setSelectedOptionAi] = React.useState({ value: '', label: lang('dashboard_every-day') })
  const [selectedOptionSmartChat, setSelectedOptionSmartChat] = React.useState({ value: '', label: lang('dashboard_every-day') })
  const [shouldRefresh, setShouldRefresh] = React.useState(false)
  const [faqConsoleSchedules, setFaqConsoleSchedules] = React.useState({
    monday: props.schedules[0].monday,
    tuesday: props.schedules[0].tuesday,
    wednesday: props.schedules[0].wednesday,
    thursday: props.schedules[0].thursday,
    friday: props.schedules[0].friday,
    saturday: props.schedules[0].saturday,
    sunday: props.schedules[0].sunday
  })
  const [aiBotSchedules, setAiBotSchedules] = React.useState({
    monday: props.schedules[1].monday,
    tuesday: props.schedules[1].tuesday,
    wednesday: props.schedules[1].wednesday,
    thursday: props.schedules[1].thursday,
    friday: props.schedules[1].friday,
    saturday: props.schedules[1].saturday,
    sunday: props.schedules[1].sunday
  })
  const [smartChatSchedules, setSmartChatSchedules] = React.useState({
    monday: props.schedules[2].monday,
    tuesday: props.schedules[2].tuesday,
    wednesday: props.schedules[2].wednesday,
    thursday: props.schedules[2].thursday,
    friday: props.schedules[2].friday,
    saturday: props.schedules[2].saturday,
    sunday: props.schedules[2].sunday
  })
  const [rangeError, setRangeError] = React.useState({})
  const [error, setError] = React.useState('')

  const handleRangeError = (params = {}) => {
    const { scheduleName, rangeError } = params
    setRangeError(prevState => ({ ...prevState, [scheduleName]: rangeError }))
  }

  const updateSchedule = ({ scheduleName, schedule, isActiveChange = false }) => {
    if (scheduleName === 'faqConsoleSchedules') {
      setFaqConsoleSchedules(schedule)
      if (isActiveChange) {
        setSelectedOptionFaq({ value: options[2], label: options[2] })
      }
    }

    if (scheduleName === 'aiBotSchedules') {
      setAiBotSchedules(schedule)
      if (isActiveChange) {
        setSelectedOptionAi({ value: options[2], label: options[2] })
      }
    }

    if (scheduleName === 'smartChatSchedules') {
      setSmartChatSchedules(schedule)
      if (isActiveChange) {
        setSelectedOptionSmartChat({ value: options[2], label: options[2] })
      }
    }

    setShouldRefresh(!shouldRefresh)
  }

  const changeDaysSelector = ({ scheduleName, d }) => {
    scheduleName === 'faqConsoleSchedules'
      ? setSelectedOptionFaq(d)
      : scheduleName === 'aiBotSchedules'
        ? setSelectedOptionAi(d)
        : setSelectedOptionSmartChat(d)

    let newSchedule = scheduleName === 'faqConsoleSchedules'
      ? faqConsoleSchedules
      :  scheduleName === 'aiBotSchedules'
        ? aiBotSchedules
        : smartChatSchedules

    if (d.value === options[0]) {
      Object.keys(newSchedule).forEach((day) => {
        newSchedule[day].isActive = true
      })
    } else if (d.value === options[1]) {
      Object.keys(newSchedule).forEach((day) => {
        if (day === 'saturday' || day === 'sunday') {
          newSchedule[day].isActive = false
        } else {
          newSchedule[day].isActive = true
        }
      })
    }

    scheduleName === 'faqConsoleSchedules'
      ? setFaqConsoleSchedules(newSchedule)
      : scheduleName === 'aiBotSchedules'
        ? setAiBotSchedules(newSchedule)
        : setSmartChatSchedules(newSchedule)

    setShouldRefresh(!shouldRefresh)
  }

  const saveSchedules = () => {
    for (const scheduleName of Object.keys(rangeError)) {
      if (Object.keys(rangeError[scheduleName]).length) {
        setError(lang('dashboard_inconsistencies-schedule-ranges'))
        return
      } else {
        if (error) setError('')
      }
    }

    faqConsoleSchedules.isActive = Object.values(faqConsoleSchedules).findIndex(elem => elem.isActive) !== -1
    faqConsoleSchedules.timeZone = props.schedules[0].timeZone

    aiBotSchedules.isActive = Object.values(aiBotSchedules).findIndex(elem => elem.isActive) !== -1
    aiBotSchedules.timeZone = props.schedules[1].timeZone

    smartChatSchedules.isActive = Object.values(smartChatSchedules).findIndex(elem => elem.isActive) !== -1
    smartChatSchedules.timeZone = props.schedules[2].timeZone

    props
      .saveSchedules(faqConsoleSchedules, aiBotSchedules, smartChatSchedules)
      .then(() => {
        props.closeModal()
      })
      .catch(() => {
        setError(lang('schedules_error_back_save'))
      })
  }

  const onChangeSchedulesContainers = (type) => {
    switch (type) {
      case 'bot':
        setIsOpenSchedules({
          faqConsoleSchedule: true,
          aiBotSchedule: false,
          smartChatSchedule : false
        })
        break
      case 'assistant':
        setIsOpenSchedules({
          faqConsoleSchedule: false,
          aiBotSchedule: true,
          smartChatSchedule : false
        })
        break
      case 'smartChat':
        setIsOpenSchedules({
          faqConsoleSchedule: false,
          aiBotSchedule: false,
          smartChatSchedule : true
        })
        break
      default:
        break
    }
  }

  return (
    <div className='schedule-modal-advanced'>
      <div className='modal-header'>
        <div className='title-container'>
          <div className='title'>{lang('faq_console_schedule_modal_title_bot')}</div>
          <div className='subtitle'>{lang('faq_console_schedule_modal_advanced_bot_subtitle')}</div>
        </div>
        <div className='close' onClick={props.closeModal}>
          <i className='fa fa-times'></i>
        </div>
      </div>
      <div className='schedules-container'>
        <div className='schedule'>
          <div
            className='schedule__header'
            onClick={() => onChangeSchedulesContainers('bot')}
            style={{
              borderBottom: !isOpenSchedules.faqConsoleSchedule ? '1px solid #e4e4e4' : null,
              paddingBottom: !isOpenSchedules.faqConsoleSchedule ? '25px' : null
            }}
          >
            <i className={`fa fa-chevron-down ${isOpenSchedules.faqConsoleSchedule ? 'fa-chevron-down--collapsed' : ''}`}></i>
          </div>
          <Collapse isOpen={isOpenSchedules.faqConsoleSchedule}>
            <DaysRange
              daysSelectorInset
              schedules={faqConsoleSchedules}
              updateSchedule={updateSchedule}
              scheduleName='faqConsoleSchedules'
              refresh={shouldRefresh}
              selectedOption={selectedOptionFaq}
              changeDaysSelector={changeDaysSelector}
              options={options.map((o) => ({ value: o, label: o }))}
              onChangeError={value => handleRangeError({ scheduleName: 'faqConsoleSchedules', rangeError: value })}
            />
          </Collapse>
        </div>
        <div className='schedule'>
          <div
            className='schedule__header'
            onClick={() => onChangeSchedulesContainers('assistant')}
            style={{
              borderBottom: !isOpenSchedules.aiBotSchedule ? '1px solid #e4e4e4' : null,
              paddingBottom: !isOpenSchedules.aiBotSchedule ? '25px' : null
            }}
          >
            <p className='schedule__title'>{lang('dashboard_operator-assistance')}</p>
            <i className={`fa fa-chevron-down ${isOpenSchedules.aiBotSchedule ? 'fa-chevron-down--collapsed' : ''}`}></i>
          </div>
          <Collapse isOpen={isOpenSchedules.aiBotSchedule}>
            <DaysRange
              daysSelectorInset
              schedules={aiBotSchedules}
              updateSchedule={updateSchedule}
              scheduleName='aiBotSchedules'
              refresh={shouldRefresh}
              selectedOption={selectedOptionAi}
              changeDaysSelector={changeDaysSelector}
              options={options.map((o) => ({ value: o, label: o }))}
              onChangeError={value => handleRangeError({ scheduleName: 'aiBotSchedules', rangeError: value })}
            />
          </Collapse>
        </div>
        <div className='schedule'>
          <div
            className='schedule__header'
            onClick={() => onChangeSchedulesContainers('smartChat')}
            style={{
              borderBottom: !isOpenSchedules.smartChatSchedule ? '1px solid #e4e4e4' : null,
              paddingBottom: !isOpenSchedules.smartChatSchedule ? '25px' : null
            }}
          >
            <p className='schedule__title'>{lang('dashboard_smartchat')}</p>
            <i className={`fa fa-chevron-down ${isOpenSchedules.smartChatSchedule ? 'fa-chevron-down--collapsed' : ''}`}></i>
          </div>
          <Collapse isOpen={isOpenSchedules.smartChatSchedule}>
            <DaysRange
              daysSelectorInset
              schedules={smartChatSchedules}
              updateSchedule={updateSchedule}
              scheduleName='smartChatSchedules'
              refresh={shouldRefresh}
              selectedOption={selectedOptionSmartChat}
              changeDaysSelector={changeDaysSelector}
              options={options.map((o) => ({ value: o, label: o }))}
              onChangeError={value => handleRangeError({ scheduleName: 'smartChatSchedules', rangeError: value })}
            />
          </Collapse>
        </div>
      </div>
      <div className='modal-footer'>
        {error && <p className='error-text'>{error}</p>}
        <div className='buttons-container'>
          <div className='action-buttons'>
            <Button secondary value={lang('dashboard_save')} onClick={saveSchedules} />
            <Button value={lang('dashboard_cancel')} onClick={props.closeModal} />
          </div>
          <button type='button' className='schedule-mode-button' onClick={props.toggleMode}>
            <i className='fa fa-clock-o fa-lg'></i>
            {lang('dashboard_basic-method')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Index
